import {
  Box,
  Typography,
  Button,
  Snackbar,
  TextField,
  InputAdornment,
  IconButton,
  LinearProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import StoreIcon from "@mui/icons-material/Store";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MuiAlert from "@mui/material/Alert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { UserInfoStyle as styles } from "./UserInfoStyle";
import { useSetting } from "../hooks/logic/useSetting";
import { CheckBox, Visibility, VisibilityOff } from "@mui/icons-material";
import ConfirmDialog from "../components/ConfirmDialog";
import AmazonSettingDialog from "../components/AmazonSettingDialog";
import BaseFilterSelect from "../components/BaseFilter";

const Setting = () => {
  const {
    inputRef,
    handleUpdateCheck,
    handleUpdate,
    detailDialogOpen,
    setDetailDialogOpen,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    changeSellerIdDialogOpen,
    setChangeSellerIdDialogOpen,
    isSeinoCorrection,
    setIsSeinoCorrection,
    seinoCorrectionVal,
    setSeinoCorrectionVal,
    baseOptions,
    selectedBaseId,
    handleBaseChange,
  } = useSetting();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          設定
        </Typography>
      </Box>
      <Box
        mt={2}
        // p={2}
        // bgcolor="#fff"
        // borderRadius={2}
        // boxShadow={2}
        mx="auto"
        width="80%" // 全体の幅を拡張
      >
        <BaseFilterSelect
          options={baseOptions}
          value={selectedBaseId}
          onSelect={handleBaseChange}
          sx={{ width: "20%", display: "flex", justifyContent: "center" }}
          labelFontSize="0.9rem"
        />
      </Box>

      <Box
        mt={2}
        p={2}
        bgcolor="#fff"
        borderRadius={2}
        boxShadow={2}
        mx="auto"
        width="80%" // 全体の幅を拡張
      >
        <Box display="flex" justifyContent="start" gap={2}>
          <Checkbox
            defaultChecked={false}
            checked={isSeinoCorrection}
            onChange={(e) => {
              setIsSeinoCorrection(e.target.checked);
            }}
            disabled={selectedBaseId === null}
          />
          <label style={{ marginTop: "8px" }}>西濃重量補正値を設定する</label>
          <FormControl size="small" sx={{ minWidth: 220 }}>
            <TextField
              label={"補正値"}
              size="small"
              // sx={{ width: "10%" }}
              InputLabelProps={{
                sx: {
                  fontSize: "0.9rem",
                },
              }}
              value={seinoCorrectionVal}
              onChange={(e) => {
                const inputValue = e.target.value;
                // // 小数点を含む数値のみ許可し、"." 単体は除外
                // if (/^\d*\.?\d*$/.test(inputValue) && inputValue !== ".") {
                //   const normalized =
                //     inputValue === "" ? "" : String(parseFloat(inputValue));
                //   setSeinoCorrectionVal(normalized);
                // }
                if (/^\d+(\.\d*)?$/.test(inputValue)) {
                  setSeinoCorrectionVal(inputValue);
                }
              }}
              disabled={!isSeinoCorrection || selectedBaseId === null}
            />
            {/* <InputLabel>補正値</InputLabel>
            <Select value={""}></Select> */}
          </FormControl>
        </Box>
      </Box>

      <Box
        mt={2}
        p={2}
        mx="auto"
        display="flex"
        justifyContent="space-around"
        gap={8}
        // justifyContent="center"
        width="10%"
      >
        <Button
          variant="contained"
          color="primary"
          fullWidth
          disabled={selectedBaseId === null}
          onClick={() => handleUpdateCheck()}
        >
          更新
        </Button>
      </Box>

      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default Setting;
